import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Container } from './style';
import { getBusinessAreasOptions } from '../utils';
import CustomButton from '../../Button';
import CheckboxCard from '../../CheckboxCard';
import { Creators as ChatbotCreators } from '../../../store/ducks/chatbot';

class BusinessArea extends Component {

  state = {}

  handleChange = (value, name) => {
    this.setState({ ...this.state, [name]: value });
  };

  submit = () => {
    this.props.setChatbotSaga({ ...this.state }, this.props);
  }

  isValid = () => {
    const selectedItems = Object.keys(this.state).filter(key => this.state[key]);

    if (selectedItems.length) {
      return true;
    }

    return false;
  }

  render() {
    const options = getBusinessAreasOptions({ trigger: this.props.trigger });

    return (
      <Container>
        {
          options.map((item, idx) => (
            <CheckboxCard
              key={idx}
              handleChange={this.handleChange}
              value={this.state[item.value]}
              name={item.value}
              title={item.value}
            />
          ))
        }
        < div style={{ width: '60%', marginTop: '15px' }}>
          <CustomButton
            disabled={!this.isValid()}
            onClick={this.submit} fullWidth title='Ok' />
        </div >
      </Container >
    )
  }

}

export default compose(connect(null, { ...ChatbotCreators }))(BusinessArea);